export const ColgroupButtonTestPageObject = (handleClick: () => void, collapsed: boolean) => ({
    getType: () => "ColgroupButton",

    click: () => handleClick(),

    isHidden: () => collapsed,
});
